import apiHandler from "middlewares/apiHandler";
import { UserRoleConfiguration } from "pages/Settings/UserRole/data/UserRoleConfiguration";

export const _getUserRoleConfiguration = async (locationId: number | undefined) => {
  return apiHandler.get<UserRoleConfiguration>(
    `location/${locationId}/userroleconfiguration`
  );
};

export const _addUserRoleConfiguration = async (model: UserRoleConfiguration) => {
  return apiHandler.post<UserRoleConfiguration>("userroleconfiguration", model);
};
